export default "data:video/mp2t;base64,ZXhwb3J0IGNvbnN0IE1TUCA9ICJtc3AiOwpleHBvcnQgY29uc3QgQ1VTVE9NRVIgPSAiY3VzdG9tZXIiOwo="